import { View, Image } from "@/components/ui";
import { PopularServices } from "../popular-services";
import { OtherServices } from "../other-services";
import { SearchBar } from "@/components/shared/search-bar";
import { NotificationBadge } from "../../notifications/notification-badge";
import { ImageBackground } from "@/components/ui/image-background";
import { useSafeAreaInsets } from "@/components/hooks/use-safe-area-insets";
import { cn, getPlatform } from "@/lib/utils";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { ToDoWidgets } from "../to-do-widgets";
import { getBackgroundTheme, getBannerTheme } from "../lib";

export function HeroSection() {
  const isWeb = getPlatform() === "web";
  const { isDesktop } = useWindowDimensions();
  const { top } = useSafeAreaInsets();
  const luceBanner = getBannerTheme();

  return (
    <>
      <ImageBackground
        padding={0}
        src={getBackgroundTheme()}
        style={{
          paddingTop: top,
          borderTopLeftRadius: isDesktop ? 24 : 0,
          borderTopRightRadius: isDesktop ? 24 : 0,
          borderBottomLeftRadius: 24,
          borderBottomRightRadius: 24,
        }}
      >
        <View className={cn(isDesktop ? "p-10" : "p-4", "flex flex-col gap-3")}>
          <View className="flex flex-row items-center gap-2">
            <SearchBar />
            {!isWeb && <NotificationBadge />}
          </View>
          {luceBanner && <Image src={luceBanner} height={112} />}
          <PopularServices />
          <View className="relative z-40 -mb-16 md:mb-0">
            <OtherServices />
          </View>
        </View>
      </ImageBackground>
      {/* This is to create a gap between the hero section and the next section */}
      <View className="h-12 md:hidden" />
      <View className="web:mt-4">
        <ToDoWidgets />
      </View>
    </>
  );
}
